import { z } from 'zod';

import { EnvironmentVariableError } from '@/src/lib/environment';

export enum Environment {
  Demo = 'demo',
  Dev = 'dev',
  Local = 'local',
  Prod = 'prod',
  Test = 'test',
}

export const EnvironmentSchema = z.nativeEnum(Environment);

export const parseEnvironment = (value: unknown): Environment | undefined => {
  const parsed = EnvironmentSchema.safeParse(value);
  if (parsed.success) {
    return parsed.data;
  }
  return undefined;
};

export const getDeploymentEnvironment = (): Environment => {
  const deploymentEnv = parseEnvironment(process.env.DEPLOYMENT_ENV);
  if (deploymentEnv === undefined) {
    throw EnvironmentVariableError.Missing('DEPLOYMENT_ENV');
  }
  return deploymentEnv;
};
